import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import HomePage from "./pages/Home/home";
import ServiceForm from "./pages/Quote/Quote_Page";
import LoginPage from "./pages/Login/loginpage";
import PrivateRoute from "./config/privaterute";
import AdminPage from "./pages/Administrador/AdminPage";
import AdminImage from "./pages/Administrador/Galeria_Administrador";
import CotizacionesAdmin from "./pages/Administrador/Cotizaciones_Administrador";
import EmpleadosAdmin from "./pages/Administrador/Empleados_Administrador";
import CasasAdmin from "./pages/Administrador/Casas_Administrador";
import PagosAdmin from "./pages/Administrador/Pagos_Administrador";
import PagosPersonalAdmin from "./pages/Administrador/PagosPersonal_Administrador";
import CasasPersonalAdmin from "./pages/Administrador/CasasPersonal_Administrador";
import NominaAdmin from "./pages/Administrador/Nomina_Administrador";
import NominaPersonalAdmin from "./pages/Administrador/NominaPersonal_Administrador";
import PagosPendientesAdmin from "./pages/Administrador/PagosPendientes_Administrador";
import ResumenAdmin from "./pages/Administrador/Resumen_Administrador";

const App = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route path="/quote" component={ServiceForm} />
        <Route path="/login" component={LoginPage} />
        <PrivateRoute exact path="/admin" component={AdminPage} />
        <PrivateRoute path="/admin/imagen" component={AdminImage} />
        <PrivateRoute path="/admin/cotizaciones" component={CotizacionesAdmin} />
        <PrivateRoute path="/admin/empleados" component={EmpleadosAdmin} />
        <PrivateRoute path="/admin/casas" component={CasasAdmin} />
        <PrivateRoute path="/admin/pagos" component={PagosAdmin} />
        <PrivateRoute path="/admin/casas-personal" component={CasasPersonalAdmin} />
        <PrivateRoute path="/admin/pagos-personal" component={PagosPersonalAdmin} />
        <PrivateRoute path="/admin/nomina" component={NominaAdmin} />
        <PrivateRoute path="/admin/nomina-personal" component={NominaPersonalAdmin} />
        <PrivateRoute path="/admin/pagos-pendientes" component={PagosPendientesAdmin} />
        <PrivateRoute path="/admin/resumen" component={ResumenAdmin} />
      </Switch>
    </Router>
  );
};

export default App;

